// AYA Multiservice — Écran 3 : récapitulatif avant confirmation (simulation).
import React from "react";
import { ArrowRight, Info, ShieldCheck } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { fmtFcfa } from "./multiserviceApi";

export default function RecapStep({ catalog, quote, onEditConfig, onEditPayment, onConfirm, submitting }) {
  if (!quote) return null;
  const op = (catalog?.operators || []).find((o) => o.id === quote.operator_id);
  const pm = (catalog?.payment_methods || []).find((m) => m.id === quote.payment_method_id);
  const typeLabel = { credit: "Crédit téléphonique", internet: "Forfait Internet", pass: "Pass et options" }[quote.recharge_type];

  return (
    <div data-testid="ms-recap-step">
      <h2 style={{ fontSize: 18, fontWeight: 800, margin: "4px 0 3px" }}>Récapitulatif de la recharge</h2>
      <p style={{ fontSize: 12, color: "#6B8577", margin: "0 0 14px" }}>Vérifiez les informations avant de confirmer.</p>

      <div className="ms-card" data-testid="ms-recap-operator-card">
        <div className="ms-card-head">
          {op && <BrandLogo brand={op.brand} size={36} />}
          <b>{quote.operator_name}</b>
          <button className="ms-edit" data-testid="ms-recap-edit-config" onClick={onEditConfig}>Modifier</button>
        </div>
        <div className="ms-line"><span>Numéro</span><b data-testid="ms-recap-phone">{quote.beneficiary_phone.replace(/(\d{2})(?=\d)/g, "$1 ")}</b></div>
        <div className="ms-line"><span>Type</span><b>{typeLabel}</b></div>
        <div className="ms-line"><span>Offre</span><b data-testid="ms-recap-offer">{quote.offer_name}</b></div>
        <div className="ms-line"><span>Validité</span><b>{quote.offer_validity}</b></div>
      </div>

      <div className="ms-card" data-testid="ms-recap-payment-details">
        <div className="ms-card-head"><b>Détails du paiement</b></div>
        <div className="ms-line"><span>Montant du service</span><b>{fmtFcfa(quote.service_amount)}</b></div>
        <div className="ms-line"><span>Frais de service</span><b>{quote.fees > 0 ? fmtFcfa(quote.fees) : "Gratuit"}</b></div>
        <div className="ms-line total"><span>Total à payer</span><b data-testid="ms-recap-total">{fmtFcfa(quote.total_amount)}</b></div>
      </div>

      <div className="ms-card" data-testid="ms-recap-payment-method">
        <div className="ms-card-head">
          {pm && <BrandLogo brand={pm.brand} size={36} />}
          <b>{quote.payment_method_name}</b>
          <button className="ms-edit" data-testid="ms-recap-edit-payment" onClick={onEditPayment}>Modifier</button>
        </div>
      </div>

      <div className="ms-info-note"><Info size={15} style={{ flexShrink: 0 }} /> La recharge simulée est généralement traitée en quelques secondes. Vous recevrez une confirmation dès l'exécution.</div>
      <div className="ms-demo-note" data-testid="ms-recap-demo-note"><ShieldCheck size={15} /> Simulation uniquement : aucune somme ne sera débitée.</div>

      <button className="ms-cta" data-testid="ms-confirm-btn" disabled={submitting} onClick={onConfirm}>
        {submitting ? "Création de la commande…" : <>Confirmer et payer — {fmtFcfa(quote.total_amount)} <ArrowRight size={17} /></>}
      </button>
      <p className="ms-legal">En continuant, vous acceptez les conditions d'utilisation d'AYA.</p>
    </div>
  );
}
